import normalizeProjectId from '@/lib/normalizeProjectId.js';

const applyPieveProjectOptimisticMutation = ({ state, payload, mutation } = {}) => {
  const previousProjects = state?.projects || [];
  const normalizedMutation = String(mutation || '')
    .trim()
    .toLowerCase();

  if (!previousProjects.length && normalizedMutation !== 'create' && normalizedMutation !== 'rollback') {
    return state;
  }

  if (normalizedMutation === 'rollback') {
    if (!Array.isArray(payload?.meta?.previousProjects)) {
      return state;
    }

    return { ...state, projects: payload.meta.previousProjects };
  }

  if (normalizedMutation === 'create') {
    const optimisticProject = payload?.meta?.optimisticProject;
    const optimisticProjectId = normalizeProjectId(optimisticProject?.id);

    if (!optimisticProjectId) {
      return state;
    }

    const nextProjects = previousProjects
      .filter((project) => normalizeProjectId(project?.id) !== optimisticProjectId)
      .map((project) => {
        if (optimisticProject?.isDefault !== true) {
          return project;
        }

        return { ...project, isDefault: false };
      })
      .concat([{ ...optimisticProject, id: optimisticProjectId, isDefault: optimisticProject?.isDefault === true }]);

    return { ...state, projects: nextProjects };
  }

  const projectId = normalizeProjectId(payload?.resourceId || payload?.projectId || payload?.meta?.projectId);

  if (!projectId) {
    return state;
  }

  if (normalizedMutation === 'update') {
    let didChange = false;
    const nextProjects = previousProjects.map((project) => {
      if (normalizeProjectId(project?.id) !== projectId) {
        return project;
      }

      const nextName = Object.prototype.hasOwnProperty.call(payload || {}, 'name') ? payload.name : project?.name;
      const nextRootPath = Object.prototype.hasOwnProperty.call(payload || {}, 'rootPath') ? payload.rootPath || null : project?.rootPath;

      if (nextName === project?.name && nextRootPath === project?.rootPath) {
        return project;
      }

      didChange = true;
      return { ...project, name: nextName, rootPath: nextRootPath };
    });

    if (!didChange) {
      return state;
    }

    return { ...state, projects: nextProjects };
  }

  if (normalizedMutation === 'remove') {
    const removedProject = previousProjects.find((project) => normalizeProjectId(project?.id) === projectId);

    if (!removedProject) {
      return state;
    }

    let nextProjects = previousProjects.filter((project) => normalizeProjectId(project?.id) !== projectId);

    if (!nextProjects.length) {
      return state;
    }

    if (removedProject?.isDefault === true && !nextProjects.some((project) => project?.isDefault === true)) {
      const fallbackProjectId = normalizeProjectId(payload?.meta?.fallbackActiveProjectId) || normalizeProjectId(nextProjects.find((project) => project?.isHome === true)?.id) || normalizeProjectId(nextProjects[0]?.id);

      nextProjects = nextProjects.map((project) => ({
        ...project,
        isDefault: normalizeProjectId(project?.id) === fallbackProjectId
      }));
    }

    return { ...state, projects: nextProjects };
  }

  return state;
};

export default applyPieveProjectOptimisticMutation;
